import PropTypes from 'prop-types';

const BACKDROPS = {
	neutral: 'bg-bgBase-300',
	success: 'bg-gradient-to-br from-success-200 to-primary-100',
};

/**
 * Full-page shell for the screens that exist precisely because the app shell's preconditions are not
 * met (no access, subscription paused, payment not yet confirmed). They deliberately render outside
 * AppShell: its sidebar, banners and credits modal would link to features that are locked.
 *
 * @param {Object} props
 * @param {'neutral'|'success'} [props.backdrop]
 * @param {string} [props.width] - Tailwind max-width for the content column (default 'max-w-md').
 */
const FullscreenLayout = ({ children, backdrop = 'neutral', width = 'max-w-md' }) => (
	<div className={`flex min-h-screen items-center justify-center py-12 ${BACKDROPS[backdrop]}`}>
		<div className={width}>{children}</div>
	</div>
);

FullscreenLayout.propTypes = {
	children: PropTypes.node.isRequired,
	backdrop: PropTypes.oneOf(['neutral', 'success']),
	width: PropTypes.string,
};

export default FullscreenLayout;
